import * as i0 from '@angular/core';
import { Directive, Input, NgModule } from '@angular/core';

class PreloadImageDirective {
    constructor() {
        this.preloaderElement = null;
    }
    ngOnChanges() {
        if (this.preloaderElement) {
            this.preloaderElement.remove();
            delete this.preloaderElement;
        }
        if (this.sbPreloadImage && this.sbPreloadImage.length) {
            // TODO: remove hidden jquery dependency
            this.preloaderElement = $('<span>').css({
                display: 'inline',
                position: 'fixed',
                top: '-9999px',
                left: '-9999px',
                width: '0px',
                height: '0px',
                visibility: 'hidden',
                'background-image': `url(${this.sbPreloadImage})`,
            });
            this.preloaderElement.appendTo('html body');
        }
    }
    ngOnDestroy() {
        if (this.preloaderElement) {
            this.preloaderElement.remove();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.10", ngImport: i0, type: PreloadImageDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "18.2.10", type: PreloadImageDirective, selector: "[sbPreloadImage]", inputs: { sbPreloadImage: "sbPreloadImage" }, usesOnChanges: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.10", ngImport: i0, type: PreloadImageDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[sbPreloadImage]',
                }]
        }], propDecorators: { sbPreloadImage: [{
                type: Input
            }] } });

class ImageModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.10", ngImport: i0, type: ImageModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.10", ngImport: i0, type: ImageModule, declarations: [PreloadImageDirective], exports: [PreloadImageDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.10", ngImport: i0, type: ImageModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.10", ngImport: i0, type: ImageModule, decorators: [{
            type: NgModule,
            args: [{
                    exports: [PreloadImageDirective],
                    declarations: [PreloadImageDirective],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { ImageModule, PreloadImageDirective };
